import { useState } from "react";
// --- components ----------------------------------------------------------------
import CreationSuite from "../components/service/CreationSuite";
import SoundLab from "../components/service/SoundLab";
import VisualStudio from "../components/service/VisualStudio";
import AcademyZone from "../components/service/AcademyZone";
import ExperienceLounge from "../components/service/ExperienceLounge";
import Make from "../components/service/Make"
// --- img ----------------------------------------------------------------
import {
  logoFavicon,
} from "../assets/images";
// --- swiper ----------------------------------------------------------------
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
// --- style ----------------------------------------------------------------
import "../styles/pages/Service.scss";

function Service() {
  // --- 데이터 ----------------------------------------------------------------
  const TABS = [
    {
      key: "creation",
      tabLabel: "CREATION SUITE",
      tabLabelKo: "음악 제작 패키지",
      title: "CREATION SUITE",
      subtitle: "AI와 함께 음악의 새로운 가능성을 여는 크리에이터 허브",
      tabContent: CreationSuite,
    },
    {
      key: "sound",
      tabLabel: "SOUND LAB",
      tabLabelKo: "음향 서비스",
      title: "SOUND LAB",
      subtitle: "감정의 온도를 조율하는 공간 녹음 믹싱 마스터링 소리의 디테일을 디자인합니다",
      tabContent: SoundLab,
    },
    {
      key: "visual",
      tabLabel: "VISUAL STUDIO",
      tabLabelKo: "촬영 서비스",
      title: "VISUAL STUDIO",
      subtitle: "음악이 눈으로 느껴지는 순간. 프로필, 영상, 비주얼 브랜딩까지 당신의 이야기를 기록합니다",
      tabContent: VisualStudio,
    },
    {
      key: "academy",
      tabLabel: "ACADEMY ZONE",
      tabLabelKo: "레슨 프로그램",
      title: "ACADEMY ZONE",
      subtitle: "배움이 끝나는 곳이 아니라, 무대가 시작되는 곳",
      tabContent: AcademyZone,
    },
    {
      key: "experience",
      tabLabel: "EXPERIENCE LOUNGE",
      tabLabelKo: "체험카페 & 공간대여",
      title: "EXPERIENCE LOUNGE",
      subtitle: "한 잔의 라떼, 한 줄의 멜로디. AI 음악 체험과 휴식이 공존하는 영감의 카페",
      tabContent: ExperienceLounge,
    },
          {
      key: "make",
      tabLabel: "MAKE",
      tabLabelKo: "제작",
      title: "MAKE",
      subtitle: "AI 음악부터 뮤직비디오, 광고 콘텐츠까지 모든 크리에이터의 아이디어가 실현되는 공간",
      tabContent: Make,
    },    
  ]
  // --- 상태 ----------------------------------------------------------------
  const [activeKey, setActiveKey] = useState(TABS[0].key);
  const activeTab = TABS.find((t) => t.key === activeKey) || TABS[0];
  const ActiveSection = activeTab.tabContent;  

  return (
    <section className='service page-wrapper'>
      {/* === 타이틀 영역 === */}
      <div className="page-wrapper__top">
        <div className='page-wrapper__title'>
          <p>
            {activeTab.subtitle}
          </p>
          <div className="page-wrapper__tit">
            <img src={logoFavicon} alt="" aria-hidden="true" />
            <h2>{activeTab.title}</h2>
          </div>
        </div>

        {/* === 탭 === */}
        <div className="service-tabs">
          <Swiper
            modules={[FreeMode]}
            slidesPerView="auto"
            freeMode
            touchStartPreventDefault={false} 
            noSwiping={false}
            className="service-tabs__swiper"
            breakpoints={{
              0: {
                spaceBetween: 8, 
              },
              768: {
                spaceBetween: 12,  
              },
              1024: {
                spaceBetween: 16, 
              },
            }}            
          >
            {TABS.map(tab => (
              <SwiperSlide key={tab.key} style={{ width: "auto" }}>
                <button
                  type="button"
                  className={`service-tab ${activeKey === tab.key ? "active" : ""}`}
                  onClick={() => setActiveKey(tab.key)}
                >
                  {tab.tabLabel}     
                  <span className="service-tab-ko">
                    {tab.tabLabelKo}
                  </span>                               
                </button>                
              </SwiperSlide>
            ))}
          </Swiper>
        </div>  
      </div>    


      {/* === 탭 컨텐츠 === */}
      <ActiveSection />
    </section>
  )
}

export default Service